const REQUEST_USER_ORGANIZATIONS = 'REQUEST_USER_ORGANIZATIONS';
const REQUEST_USER_ORGANIZATIONS_SUCCESS = 'REQUEST_USER_ORGANIZATIONS_SUCCESS';
const REQUEST_USER_ORGANIZATIONS_FAIL = 'REQUEST_USER_ORGANIZATIONS_FAIL';

export {
  REQUEST_USER_ORGANIZATIONS,
  REQUEST_USER_ORGANIZATIONS_SUCCESS,
  REQUEST_USER_ORGANIZATIONS_FAIL,
};
